var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rounded rounded-lg overflow-hidden bg-white shadow shadow-md"},[_c('div',{staticClass:"bg-black text-white p-5 font-bold"},[_vm._t("header")],2),_c('div',{class:{'p-6': this.padding }},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }